export const POPULATION = 'population';
export const AREA = "AREA"
export const MEDIAN_INCOME = 'MEDIAN_INCOME';
export const PEOPLE_PER_MI2 = 'people_per_mi2';
export const HOUSEHOLDS = 'HOUSEHOLDS';
export const TARGET_AUDIENCE = 'targetAudience'
export const ROAD_DENSITY = 'road_density_per_mi2'
export const GINI_INDEX = 'GINI_INDEX';
export const POPULATION_GROWTH_TREND = 'POPULATION_GROWTH_TREND'
export const MEDIAN_HOUSEHOLD_INCOME_TREND = 'MEDIAN_HOUSEHOLD_INCOME_TREND'
export const MEDIAN_HOUSING_SALE_COST_TREND = 'MEDIAN_HOUSING_SALE_COST_TREND'
export const MEDIAN_GROSS_RENT_TREND = 'MEDIAN_GROSS_RENT_TREND'
export const CUMULATIVE_TRAFFIC_INTENSITY = 'CUMULATIVE_TRAFFIC_INTENSITY'
export const MEDIAN_HOUSING_SALE_COST = 'MEDIAN_HOUSING_SALE_COST'
export const MEDIAN_GROSS_RENT = 'MEDIAN_GROSS_RENT'
export const WEALTH_INDEX_CONST = 'WEALTH_INDEX'
export const WEALTH_INDEX_BY_COUNTRY= 'WEALTH_INDEX_by_country'
export const WEALTH_INDEX_BY_STATE= 'WEALTH_INDEX_by_state'
export const HEALTH_INDEX_CONST = 'HEALTH_INDEX'
export const HEALTH_INDEX_BY_COUNTRY= 'HEALTH_INDEX_by_country'
export const HEALTH_INDEX_BY_STATE= 'HEALTH_INDEX_by_state'
export const WISE_INDEX_CONST = 'WISE_INDEX'
export const WISE_INDEX_BY_COUNTRY= 'WISE_INDEX_by_country'
export const WISE_INDEX_BY_STATE= 'WISE_INDEX_by_state'
export const COMBINED_HWW_CONST = 'HWW_INDEX'
/**
 * The attribution every Map AI derived metric's hint ends with. Kept separate
 * from the descriptions so a caller can slot a sentence of its own in front of
 * it - the hint dialog splits on this word to lay the two out.
 */
export const MAP_AI_SOURCE_NOTE = 'Source: Map AI methodology'

/**
 * What the score is. Read by both places that explain it - the right menu's
 * indicator hint and the popup's overview - so the two cannot drift into
 * describing the same number differently. Carries no attribution: each caller
 * appends `MAP_AI_SOURCE_NOTE` last.
 */
export const COMBINED_HWW_DESCRIPTION =
  'This all-in-one score blends health, income, and education data to give you an instant feel for the overall quality of life in the neighborhood. Perfect for quickly comparing areas and finding the right fit.'
export const COMBINED_HWW_BY_COUNTRY = 'HWW_INDEX_by_country'
export const COMBINED_HWW_BY_STATE = 'HWW_INDEX_by_state'
export const LIFE_EXPECTANCY = 'LIFE_EXPECTANCY'
export const CONVENIENCE_STORES = 'CONVENIENCE_STORES'
export const DRUGSTORES = 'DRUGSTORES'
export const RETAIL = 'RETAIL'
export const BEAUTY = 'BEAUTY'
export const UNEMPLOYMENT_RATIO = 'UNEMPLOYMENT_RATIO'
export const UNINSURED_RATIO = 'UNINSURED_RATIO'
export const HOME_OWNERSHIP_RATIO = 'HOME_OWNERSHIP_RATIO'
export const CRIME_RATE = 'CRIME_RATE'

export const SMOKING_RATE = 'SMOKERS_FRACTION'
export const BINGE_DRINKING_RATE = 'DRINKERS_FRACTION'
export const OBESITY_RATE = 'OBESITY_FRACTION'
export const DIABETES_PREVALENCE = 'DIABETES_FRACTION'
export const CANCER_PREVALENCE = 'CANCER_FRACTION'
export const HEART_DISEASES_PREVALENCE = 'HEART_DISEASES_FRACTION'
export const AIR_POLLUTION = 'AIR_POLLUTION'

export const PATIENT_TO_PHYSICIAN_RATIO = 'PRIMARY_CARE_PHYSICIANS_RATIO'
export const PATIENT_TO_DENTIST_RATIO = 'DENTISTS_RATIO'
export const PATIENT_TO_THERAPIST_RATIO = 'MENTAL_HEALTH_PROVIDERS_RATIO'

export const AGE_SEX_DISTRIBUTION_CHART = 'AGE_SEX_DISTRIBUTION_CHART'
export const EMPLOYMENT_CHART = 'EMPLOYMENT_CHART'
export const VACANCY_CHART = 'VACANCY_CHART'
export const GROSS_RENT_DISTRIBUTION_CHART = 'GROSS_RENT_DISTRIBUTION_CHART'
export const HOUSING_SELL_PRICE_DISTRIBUTION_CHART = 'HOUSING_SELL_PRICE_DISTRIBUTION_CHART'
export const TENURE_CHART = 'TENURE_CHART'
export const NUMBER_OF_ROOMS_CHART = 'NUMBER_OF_ROOMS_CHART'
export const EDUCATION_ATTAINMENT_CHART = 'EDUCATION_ATTAINMENT_CHART'
export const INSURANCE_DISTRIBUTION_CHART = 'INSURANCE_DISTRIBUTION_CHART'
export const POPULATION_BY_YEARS_CHART = 'POPULATION_BY_YEARS'
export const RACE_DISTRIBUTION_CHART = 'RACE_DISTRIBUTION_CHART'
export const INCOME_DISTRIBUTION_CHART = 'INCOME_DISTRIBUTION_CHART'
export const ROAD_DENSITY_CHART = 'ROAD_DENSITY_CHART'
export const TRAFFIC_INTENSITY_CHART = 'TRAFFIC_INTENSITY_CHART'
export const COMPETITORS_POI_CHART = 'COMPETITORS_CHART'
export const BEAUTY_POI_CHART = 'BEAUTY_POI_CHART'
export const FAMILY_POI_CHART = 'FAMILY_POI_CHART'
export const RETIREMENT_POI_CHART = 'RETIREMENT_POI_CHART'
export const CONVENIENCE_POI_CHART = 'CONVENIENCE_POI_CHART'
export const FINANCIAL_SERVICES_POI_CHART = 'FINANCIAL_SERVICES_POI_CHART'
export const OUTDOOR_POI_CHART = 'OUTDOOR_POI_CHART'
export const HEALTHCARE_POI_CHART = 'HEALTHCARE_POI_CHART'
export const TARGET_AUDIENCE_CHART = 'TARGET_AUDIENCE_CHART'
export const SCHOOLS_POI = 'SCHOOLS_POI'
export const COMMUNITY_CRIME_RATE = 'INDIVIDUAL_CRIMES'
export const BUSINESS_CRIME_RATE = 'BUSINESS_CRIMES'
export const GENDER_PAY_GAP = 'GENDER_PAY_GAP'
export const UNHEALTHY_BEHAVIOUR_INDEX = 'UNHEALTHY_BEHAVIOUR_INDEX'
export const SPECIAL_HEALTH_CARE_NEEDS_INDEX = 'SPECIAL_HEALTH_CARE_NEEDS_INDEX'

export const PRESIDENTIAL_ELECTIONS_RESULTS2020 = 'PRESIDENTIAL_ELECTIONS_RESULTS2020'
export const PRESIDENTIAL_ELECTIONS_RESULTS2024 = 'PRESIDENTIAL_ELECTIONS_RESULTS2024'
// +population if Trump is winner, -population if Biden is
export const BIDEN_VS_TRUMP_2020_POPULATION = 'BIDEN_VS_TRUMP_2020_POPULATION'
export const HARRIS_VS_TRUMP_2024_POPULATION = 'HARRIS_VS_TRUMP_2024_POPULATION'
export const HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS = 'HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS'
export const SENATE_ELECTION_2022_RESULTS = 'SENATE_ELECTION_2022_RESULTS'
export const BACHELORS_DEGREE_OR_HIGHER_FRACTION = 'BACHELORS_DEGREE_OR_HIGHER_FRACTION'
export const STRUCTURE_BUILT_MEDIAN_YEAR = 'STRUCTURE_BUILT_MEDIAN_YEAR'
export const MEDIAN_TENURE = 'MEDIAN_TENURE'
export const VIOLENT_CRIME_RATE = 'VIOLENT_CRIME_RATE'
export const PROPERTY_CRIME_RATE = 'PROPERTY_CRIME_RATE'
export const HOME_PRICE_TO_INCOME_RATIO = 'HOME_PRICE_TO_INCOME_RATIO'
export const MEDIAN_AGE = 'MEDIAN_AGE'
export const MEDIAN_NUMBER_OF_ROOMS = 'MEDIAN_NUMBER_OF_ROOMS'
export const AVERAGE_HOUSEHOLD_SIZE = 'AVERAGE_HOUSEHOLD_SIZE'
export const NUMBER_OF_VEHICLES_AVAILABLE = 'NUMBER_OF_VEHICLES_AVAILABLE'
export const WORK_AT_HOME = 'WORK_AT_HOME'
export const AVERAGE_TRAVEL_TIME_TO_WORK = 'AVERAGE_TRAVEL_TIME_TO_WORK'

export const LAND_AREA_FRACTION = 'LAND_AREA_FRACTION'
export const AVERAGE_ANNUAL_SPENDING = 'AVERAGE_ANNUAL_SPENDING'

export const HOUSEHOLDS_BY_VEHICLES_CHART = 'HOUSEHOLDS_BY_VEHICLES_CHART'
export const MARITAL_STATUS_CHART = 'MARITAL_STATUS_CHART'
export const WORK_COMMUTE_MODES_CHART = 'WORK_COMMUTE_MODES_CHART'
export const TRAVEL_TIME_TO_WORK_CHART = 'TRAVEL_TIME_TO_WORK_CHART'
export const TIME_OF_DEPARTURE_TO_WORK_CHART = 'TIME_TO_DEPARTURE_TO_WORK_CHART'
export const AIR_QUALITY_DISTRIBUTION_CHART = 'AIR_QUALITY_DISTRIBUTION_CHART'
export const INCOME_MEDIANS_BY_YEARS_CHART = 'INCOME_MEDIANS_BY_YEARS_CHART'
export const UNEMPLOYMENT_RATE_BY_YEARS_CHART = 'UNEMPLOYMENT_RATE_BY_YEARS_CHART'
export const AIR_POLLUTION_INDEX = 'AIR_POLLUTION_INDEX'


export const voteDataFeatures = [
PRESIDENTIAL_ELECTIONS_RESULTS2020,
PRESIDENTIAL_ELECTIONS_RESULTS2024,
BIDEN_VS_TRUMP_2020_POPULATION,
HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS,
SENATE_ELECTION_2022_RESULTS

  //This is colored by colorMapByCells() so we dont need them in setVotersData()
// HARRIS_VS_TRUMP_2024_POPULATION,
]

export const cdcBulkFeatures = [
  SMOKING_RATE,
  BINGE_DRINKING_RATE,
  OBESITY_RATE,
  DIABETES_PREVALENCE,
  CANCER_PREVALENCE,
  HEART_DISEASES_PREVALENCE
]

export const chrBulkFeatures = [
  PATIENT_TO_PHYSICIAN_RATIO,
  PATIENT_TO_DENTIST_RATIO,
  PATIENT_TO_THERAPIST_RATIO,
  AIR_POLLUTION
]

export const crimeRateByVictimsTypeBulkFeatures = [
  COMMUNITY_CRIME_RATE,
  BUSINESS_CRIME_RATE
]

export const crimeRatesList = [
  COMMUNITY_CRIME_RATE,
  BUSINESS_CRIME_RATE,
  CRIME_RATE,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE
]

export const hwwFeatures = [
  WEALTH_INDEX_BY_COUNTRY,
  WEALTH_INDEX_BY_STATE,
  WEALTH_INDEX_CONST,
  HEALTH_INDEX_BY_COUNTRY,
  HEALTH_INDEX_BY_STATE,
  HEALTH_INDEX_CONST,
  WISE_INDEX_BY_COUNTRY,
  WISE_INDEX_BY_STATE,
  WISE_INDEX_CONST,
  COMBINED_HWW_BY_COUNTRY,
  COMBINED_HWW_BY_STATE,
  COMBINED_HWW_CONST,
]

export const availableInBulkFeatures = [
  ...cdcBulkFeatures,
  ...chrBulkFeatures,
  ...crimeRateByVictimsTypeBulkFeatures,
  LIFE_EXPECTANCY,
  POPULATION_GROWTH_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_GROSS_RENT_TREND,
  CUMULATIVE_TRAFFIC_INTENSITY,
  MEDIAN_HOUSING_SALE_COST,
  MEDIAN_GROSS_RENT,
  UNINSURED_RATIO,
  UNEMPLOYMENT_RATIO,
  HOME_OWNERSHIP_RATIO,
  CRIME_RATE,
  GENDER_PAY_GAP,
  UNHEALTHY_BEHAVIOUR_INDEX,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  BIDEN_VS_TRUMP_2020_POPULATION,
  HARRIS_VS_TRUMP_2024_POPULATION,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  MEDIAN_TENURE,

  ...hwwFeatures,
  GINI_INDEX,
  MEDIAN_INCOME,
  HOUSEHOLDS,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  AVERAGE_HOUSEHOLD_SIZE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  AVERAGE_ANNUAL_SPENDING,
  AIR_POLLUTION_INDEX
]

export const targetAudienceIndustries = [
  CONVENIENCE_STORES,
  DRUGSTORES,
  RETAIL,
  BEAUTY
]

export const trendLayers: string[] = [
  POPULATION_GROWTH_TREND,
  MEDIAN_GROSS_RENT_TREND,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
]

export const ratioLayers = [
  UNINSURED_RATIO,
  UNEMPLOYMENT_RATIO,
  HOME_OWNERSHIP_RATIO
]

// Meaning features which values were written into feature.state to then read by mapbox
//TODO: UPDATE ON EACH STATE DEPENDENT FEATURE ADDING
export const writtenInStateFeatures = [
  ...targetAudienceIndustries,
  ...trendLayers,
  ...cdcBulkFeatures,
  ...chrBulkFeatures,
  ...crimeRateByVictimsTypeBulkFeatures,
  ...voteDataFeatures,
  ...hwwFeatures,
  CUMULATIVE_TRAFFIC_INTENSITY,
  LIFE_EXPECTANCY,
  MEDIAN_HOUSING_SALE_COST,
  MEDIAN_GROSS_RENT,
  POPULATION_GROWTH_TREND,
  COMBINED_HWW_BY_STATE,
  COMBINED_HWW_BY_COUNTRY,
  UNINSURED_RATIO,
  UNEMPLOYMENT_RATIO,
  HOME_OWNERSHIP_RATIO,
  CRIME_RATE,
  AIR_POLLUTION,
  GENDER_PAY_GAP,
  UNHEALTHY_BEHAVIOUR_INDEX,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  BIDEN_VS_TRUMP_2020_POPULATION,
  HARRIS_VS_TRUMP_2024_POPULATION,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  MEDIAN_TENURE,
  GINI_INDEX,
  MEDIAN_INCOME,
  HOUSEHOLDS,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  AVERAGE_HOUSEHOLD_SIZE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  AVERAGE_ANNUAL_SPENDING,
  AIR_POLLUTION_INDEX
]


export const allFeatureNames = [
  ...cdcBulkFeatures,
  ...chrBulkFeatures,
  ...crimeRateByVictimsTypeBulkFeatures,
  ...voteDataFeatures,
  POPULATION,
  MEDIAN_INCOME,
  PEOPLE_PER_MI2,
  HOUSEHOLDS,
  TARGET_AUDIENCE,
  ROAD_DENSITY,
  GINI_INDEX,
  POPULATION_GROWTH_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_GROSS_RENT_TREND,
  CUMULATIVE_TRAFFIC_INTENSITY,
  MEDIAN_HOUSING_SALE_COST,
  MEDIAN_GROSS_RENT,
  WEALTH_INDEX_BY_COUNTRY,
  WEALTH_INDEX_BY_STATE,
  HEALTH_INDEX_BY_COUNTRY,
  HEALTH_INDEX_BY_STATE,
  WISE_INDEX_BY_COUNTRY,
  WISE_INDEX_BY_STATE,
  COMBINED_HWW_BY_COUNTRY,
  COMBINED_HWW_BY_STATE,
  LIFE_EXPECTANCY,
  CONVENIENCE_STORES,
  BEAUTY,
  DRUGSTORES,
  RETAIL,
  UNINSURED_RATIO,
  UNEMPLOYMENT_RATIO,
  HOME_OWNERSHIP_RATIO,
  SCHOOLS_POI,
  CRIME_RATE,
  GENDER_PAY_GAP,
  UNHEALTHY_BEHAVIOUR_INDEX,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  BIDEN_VS_TRUMP_2020_POPULATION,
  HARRIS_VS_TRUMP_2024_POPULATION,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  MEDIAN_TENURE,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  AVERAGE_HOUSEHOLD_SIZE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  AVERAGE_ANNUAL_SPENDING,
  AIR_POLLUTION_INDEX
]


export const availableFeatures = [
  'AREA',
  'POPULATION',
  'POPULATION_DENSITY_MILES',
  MEDIAN_INCOME,
  HOUSEHOLDS,
  WISE_INDEX_CONST,
  WEALTH_INDEX_CONST,
  HEALTH_INDEX_CONST,
  'ROAD_LENGTH',
  'POINTS_OF_INTEREST',
  'AGE_SEX',
  POPULATION_BY_YEARS_CHART,
  'INCOME_DISTRIBUTION',
  'EDUCATION_ATTAINMENT',
  'HOUSEHOLDS_INCOME',
  'HOUSEHOLD_INCOME_MEDIAN_BY_YEARS',
  'INSURANCE',
  'EMPLOYMENT',
  'HOME_OWNERSHIP',
  'HOUSING_SALE_COST',
  'HOUSING_SALE_COST_MEDIANS_BY_YEARS',
  'HOUSING_AGGREGATED_PRICE',
  'HOUSING_ROOMS',
  'HOUSING_GROSS_RENT',
  'HOUSING_GROSS_RENT_MEDIANS_BY_YEARS',
  'LIFE_EXPECTANCY',
  OBESITY_RATE,
  'SMOKERS_FRACTION',
  'DRINKERS_FRACTION',
  'SEDENTARY_FRACTION',
  'DIABETES_FRACTION',
  'CANCER_FRACTION',
  'HEART_DISEASES_FRACTION',
  'BAD_HEALTH_SELF_RATED_FRACTION',
  'PRIMARY_CARE_PHYSICIANS',
  'DENTISTS',
  'MENTAL_HEALTH_PROVIDERS',
  'AIR_POLLUTION',
  'TRAFFIC_INTENSITY',
  'TARGET_AUDIENCE',
  'GINI_INDEX',
  GENDER_PAY_GAP,
  MEDIAN_GROSS_RENT,
  MEDIAN_HOUSING_SALE_COST,
  HOME_OWNERSHIP_RATIO,
  UNINSURED_RATIO,
  MEDIAN_GROSS_RENT_TREND,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
  UNEMPLOYMENT_RATIO,
  POPULATION_GROWTH_TREND,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  UNHEALTHY_BEHAVIOUR_INDEX,
  BIDEN_VS_TRUMP_2020_POPULATION,
  HARRIS_VS_TRUMP_2024_POPULATION,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  MEDIAN_TENURE,
  "CRIME_RATE",
  "INDIVIDUAL_CRIMES",
  "BUSINESS_CRIMES",
  PATIENT_TO_THERAPIST_RATIO,
  PATIENT_TO_PHYSICIAN_RATIO,
  PATIENT_TO_DENTIST_RATIO,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  LAND_AREA_FRACTION,
  AVERAGE_HOUSEHOLD_SIZE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  LAND_AREA_FRACTION,
  AVERAGE_ANNUAL_SPENDING,
  AIR_POLLUTION_INDEX
]

export const featuresToMultiplyBy100 = [
  OBESITY_RATE,
  SMOKING_RATE,
  UNINSURED_RATIO,
  GENDER_PAY_GAP,
  HOME_OWNERSHIP_RATIO,
  DIABETES_PREVALENCE,
  BINGE_DRINKING_RATE,
  HEART_DISEASES_PREVALENCE,
  UNEMPLOYMENT_RATIO,
  CANCER_PREVALENCE,
  UNHEALTHY_BEHAVIOUR_INDEX,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX
]

export const featuresToCompareToNationalPopup = [
  MEDIAN_INCOME,
  MEDIAN_TENURE,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  POPULATION_GROWTH_TREND,
  LIFE_EXPECTANCY,
  OBESITY_RATE,
  SMOKING_RATE,
  BINGE_DRINKING_RATE,
  DIABETES_PREVALENCE,
  CANCER_PREVALENCE,
  HEART_DISEASES_PREVALENCE,
  MEDIAN_GROSS_RENT_TREND,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
  UNEMPLOYMENT_RATIO,
  AIR_POLLUTION,
  GINI_INDEX,
  GENDER_PAY_GAP,
  MEDIAN_GROSS_RENT,
  MEDIAN_HOUSING_SALE_COST,
  HOME_OWNERSHIP_RATIO,
  UNHEALTHY_BEHAVIOUR_INDEX,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  UNINSURED_RATIO,
  CRIME_RATE,
  COMMUNITY_CRIME_RATE,
  BUSINESS_CRIME_RATE,
  PATIENT_TO_DENTIST_RATIO,
  PATIENT_TO_PHYSICIAN_RATIO,
  PATIENT_TO_THERAPIST_RATIO,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  AVERAGE_HOUSEHOLD_SIZE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  AVERAGE_ANNUAL_SPENDING,
  AIR_POLLUTION_INDEX
].map(feature => feature.toUpperCase());


//FIXME feature duplication due to differences between tile server and backend naming different
export const arbitraryCellPopupFeatures = [
  "AREA",
  "POPULATION",
  "POPULATION_DENSITY_MILES",
  "MEDIAN_INCOME",
  "HOUSEHOLDS",
  "WEALTH_INDEX",
  "HEALTH_INDEX",
  "WISE_INDEX",
  "LIFE_EXPECTANCY",
  OBESITY_RATE,
  "SMOKERS_FRACTION",
  "DRINKERS_FRACTION",
  // "SEDENTARY_FRACTION",
  "DIABETES_FRACTION",
  "CANCER_FRACTION",
  "HEART_DISEASES_FRACTION",
  "BAD_HEALTH_SELF_RATED_FRACTION",
  "PRIMARY_CARE_PHYSICIANS",
  "DENTISTS",
  "MENTAL_HEALTH_PROVIDERS",
  "AIR_POLLUTION",
  // "TARGET_AUDIENCE",
  "GINI_INDEX",
  CRIME_RATE,
  COMMUNITY_CRIME_RATE,
  BUSINESS_CRIME_RATE,
  PATIENT_TO_DENTIST_RATIO,
  PATIENT_TO_PHYSICIAN_RATIO,
  PATIENT_TO_THERAPIST_RATIO,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  MEDIAN_TENURE,
  VIOLENT_CRIME_RATE,
  PROPERTY_CRIME_RATE,
  HOME_PRICE_TO_INCOME_RATIO,
  MEDIAN_AGE,
  MEDIAN_NUMBER_OF_ROOMS,
  AVERAGE_HOUSEHOLD_SIZE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  WORK_AT_HOME,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  AIR_POLLUTION_INDEX
]

